import React from "react";
import {
  Modal,
  Form,
  Checkbox,
  Row,
  Col,
  Typography,
  Card,
  Radio,
  InputNumber,
  DatePicker,
  Button,
  TreeSelect,
  Space,
  TimePicker,
  Divider,
} from "antd";
import { observer } from "mobx-react";
import { articlesStore } from "../../store/content/article/ArticlesStore";

export const ArticlePublish = observer(() => {
  const [form] = Form.useForm();

  const { publishStore } = articlesStore;

  const onPublish = () => {
    form.validateFields().then((values) => {
      publishStore.save(values);
    });
  };

  return (
    <Modal
      title="Publish"
      visible={true}
      confirmLoading={publishStore.saving}
      maskClosable={false}
      // onOk={ok}
      onCancel={() => publishStore.close()}
      width="80%"
      footer={null}
    >
      <Row gutter={16}>
        <Col span={12}>
          <Card
            size="small"
            title={publishStore.article?.title}
            headStyle={{ textAlign: "center" }}
            style={{ height: "100%" }}
            extra={
              <Button type="link" onClick={() => publishStore.edit()}>
                Edit
              </Button>
            }
          >
            <Typography.Paragraph>{publishStore.article?.description}</Typography.Paragraph>
            <Divider />
            {publishStore.article?.images?.length > 0 && (
              <img
                alt=""
                style={{ maxHeight: 120 }}
                src={`https://${process.env.REACT_APP_CLOUDFRONT}.cloudfront.net/${publishStore.article?.images[0].url}`}
              />
            )}

            {publishStore.article?.images?.length > 0 && <Divider />}

            {publishStore.sections.map((x, i) => {
              if (x.sectionType === "subtitle") {
                return (
                  <Typography.Paragraph strong key={i + ""}>
                    {x.sectionContent}
                  </Typography.Paragraph>
                );
              } else {
                return <Typography.Paragraph key={i + ""}>{x.sectionContent}</Typography.Paragraph>;
              }
            })}
          </Card>
        </Col>
        <Col span={12}>
          <Card size="small" title="Publish" headStyle={{ textAlign: "center" }} style={{ height: "100%" }}>
            <Form form={form} labelCol={{ span: 8 }} initialValues={publishStore.publish} wrapperCol={{ span: 16 }}>
              <Form.Item name="type" wrapperCol={{ offset: 2 }} style={{ textAlign: "center" }}>
                <Radio.Group onChange={(e) => (publishStore.publish.type = e.target.value)}>
                  <Radio.Button value="All">To All</Radio.Button>
                  <Radio.Button value="Community">To Community</Radio.Button>
                  <Radio.Button value="Individual">To Individual</Radio.Button>
                </Radio.Group>
              </Form.Item>
              {publishStore.publish.type === "All" && (
                <div>
                  <Form.Item
                    name="publishDate"
                    label="Release Date"
                    rules={[{ required: true, message: "Please select release date" }]}
                  >
                    <DatePicker showTime />
                  </Form.Item>
                </div>
              )}
              {publishStore.publish.type === "Community" && (
                <div>
                  <Form.Item
                    label="Community"
                    name="communityIds"
                    rules={[{ required: true, message: "Please select community" }]}
                  >
                    <TreeSelect treeData={publishStore.regionTree} treeCheckable />
                  </Form.Item>

                  <Form.Item
                    name="publishDate"
                    label="Release Date"
                    rules={[{ required: true, message: "Please select release date" }]}
                  >
                    <DatePicker showTime />
                  </Form.Item>
                  <Form.Item name="onlyNotReached" wrapperCol={{ span: 16, offset: 8 }}>
                    <Checkbox></Checkbox> Release this article to community which has not reached.
                  </Form.Item>
                </div>
              )}
              {publishStore.publish.type === "Individual" && (
                <div>
                  <Form.Item label="Rlease Time" name="publishToNewUser">
                    <Radio.Group onChange={(e) => (publishStore.publish.publishToNewUser = e.target.value)}>
                      <Space direction="vertical">
                        <Radio value={true}>Rlease this article to every new user.</Radio>
                        <Radio value={false}>Rlease this article to new users on:</Radio>
                      </Space>
                    </Radio.Group>
                  </Form.Item>
                  {!publishStore.publish.publishToNewUser && (
                    <div>
                      <Form.Item
                        label="Day"
                        name="publishDay"
                        rules={[{ required: true, type: "number", min: 1, message: "Please input release day" }]}
                      >
                        <InputNumber min={1} defaultValue={1} />
                      </Form.Item>
                      <Form.Item
                        label="Time"
                        name="publishTime"
                        rules={[{ required: true, message: "Please input release time" }]}
                      >
                        <TimePicker />
                      </Form.Item>
                    </div>
                  )}
                </div>
              )}
              <Form.Item name="commentType" label="Comment Type">
                <Radio.Group>
                  <Radio value={"None"}>None</Radio>
                  <Radio value={"Private"}>Self Visible</Radio>
                  <Radio value={"Public"}>Public</Radio>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                name="platform"
                label="Platform"
                rules={[{ required: true, type: "array", min: 1, message: "Please select at least a platform" }]}
              >
                <Checkbox.Group options={["app", "web"]}></Checkbox.Group>
              </Form.Item>
              {publishStore.article?.type === "Deals" && (
                <Form.Item
                  name="start"
                  label="Start Date"
                  rules={[{ required: true, message: "Please input start date" }]}
                >
                  <DatePicker />
                </Form.Item>
              )}
              {publishStore.article?.type === "Deals" && (
                <Form.Item name="end" label="End Date" rules={[{ required: true, message: "Please input end date" }]}>
                  <DatePicker />
                </Form.Item>
              )}
              <Form.Item style={{ textAlign: "center" }} wrapperCol={{ offset: 2 }}>
                <Button onClick={onPublish} type="primary">
                  Publish
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
    </Modal>
  );
});
